/**
 * URL builders for the admin routes declared in `router.tsx` (SPEC-FRONTEND §7).
 * Use these instead of string literals so links survive route changes.
 */
type Id = number | string;

export const paths = {
  login: '/login',
  dashboard: '/',
  users: '/users',
  usersBlocking: '/users/blocking',
  user: (id: Id) => `/users/${id}`,
  verifications: '/verifications',
  verification: (id: Id) => `/verifications/${id}`,
  shipments: '/shipments',
  shipmentsSuspicious: '/shipments/suspicious',
  shipment: (id: Id) => `/shipments/${id}`,
  deals: '/deals',
  deal: (id: Id) => `/deals/${id}`,
  complaints: '/complaints',
  complaint: (id: Id) => `/complaints/${id}`,
  settings: '/settings',
  outbox: '/outbox',
  audit: '/audit',
} as const;
